import { render, staticRenderFns } from "./stockEdgeworkAllowanceEditor.vue?vue&type=template&id=2293e608&"
import script from "./stockEdgeworkAllowanceEditor.vue?vue&type=script&lang=js&"
export * from "./stockEdgeworkAllowanceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports